import { render, staticRenderFns } from "./ConvenioDetalhes.vue?vue&type=template&id=8fb19fee"
import script from "./ConvenioDetalhes.vue?vue&type=script&lang=js"
export * from "./ConvenioDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports